import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import bowser from 'bowser';

import { getSearchBar } from 'selectors';
import * as actions from 'actions';

class SearchBar extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const value = event.target.value;
    this.props.onSearchQueryChange(value);
  }

  handleKeyUp(event) {
    if (event.keyCode === 27 && this.props.onEscape) {
      this.props.onEscape();
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.onSearchInitiate(this.refs.input.value);
  }

  render() {
    return (
      <div className="SearchBar">
        <form action="." onSubmit={this.handleSubmit}>
          <input
            type="search"
            ref="input"
            placeholder={__('members.search.placeholder')}
            autoFocus={!bowser.mobile}
            value={this.props.query}
            onChange={this.handleChange}
            onKeyUp={this.handleKeyUp}
          />
        </form>
      </div>
    );
  }
}

SearchBar.propTypes = {
  query: PropTypes.string,
  onSearchInitiate: PropTypes.func,
  onSearchQueryChange: PropTypes.func,
  onEscape: PropTypes.func
};

const mapStateToProps = state => {
  return {
    ...getSearchBar(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSearchInitiate: term => {
      dispatch(actions.searchInitiate(term));
    },
    onSearchQueryChange: query => {
      dispatch(actions.searchUpdateQuery(query));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBar);




/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/SearchBar/index.js
 **/